export const pickupTransitionsTags = [
  'PickupTransitions',
] as const;
